import type { AddressFieldsValues } from '@backmarket/http-api/src/api-specs-shipping/address/address-validation.types'
import type { StripNullish } from '@backmarket/utils/types/StripNullish'

export type FormValues = Required<
  StripNullish<
    Pick<
      AddressFieldsValues,
      | 'firstName'
      | 'lastName'
      | 'city'
      | 'company'
      | 'street'
      | 'postalCode'
      | 'country'
      | 'phone'
      | 'stateOrProvince'
      | 'label'
    >
  >
> &
  Pick<AddressFieldsValues, 'firstNamePronunciation' | 'lastNamePronunciation'>

export const METADATA = { scope: 'seller' } as const
